/*
* browserify
* require javascript
*/
global.jQuery = require('jquery');
var parsley = require('parsleyjs');
var i18n_ja = require('parsleyjs/dist/i18n/ja.js');
Parsley.setLocale('ja');

//require('./check.js');
//import './_test-app.js';

/*
* setting variables
*
*/

//公開版
var CHECK_SHEET_GAS = "https://script.google.com/macros/s/AKfycbyddwYEzL_xzVCmUJ6rf770ogbhJBKLKcSsrgCKGC1C_Re961Cd0oZls8BC4QEl4LlI/exec";
var WRITE_SHEET_GAS = "https://script.google.com/macros/s/AKfycbzoENOZBdNbjpgmiM9Lm4jvTE7K3YLb1d_FuTmsZCNpcBE47CtEYoNrKzKHblqpxjOlRA/exec";
var SEND_MAIL_GAS = 'https://script.google.com/macros/s/AKfycbx1VbzyoBhxnEG4Ao6OiUWVu_ZSvypYJRu3U79-o60XHdiYc47tQFoBK6UrRsYQx-N0/exec';
var BLOCK_ARREY = ['A','B','C','D','E','F','G','H','I','J'];

//価格
var price = {
  A: 1500, B: 1000, C: 1500, D: 1000, E: 1000,
  F: 2500, G: 2500, H: 2500, I: 2500, J: 2500,
  AC: 3500, BC: 3500, JC: 4000,
  BEX: 1500, JEX: 1000,
  "電源": 500, "ワゴン": 3000, "ラック": 3000
}
// 電気仕様不可能設定
var not_ene = {
  B8:true, B9:true, B10:true, B11:true, B12:true, B13:true, B14:true, B15:true,
  D1:true, D2:true, D3:true, D4:true, D5:true, D6:true, D7:true, D8:true, D9:true, D10:true, D11:true, D12:true,
  E1:true, E2:true, E3:true, E4:true, E5:true, E6:true, E7:true, E8:true, E9:true,
  I1:true, I2:true, I3:true, I4:true, I5:true, I6:true, I7:true, I8:true, I9:true, I10:true, I11:true, I12:true, I13:true, I14:true, I15:true,
  J1:true, J2:true, J3:true, J4:true, J5:true, J6:true, J7:true, J8:true, J9:true, J10:true, J11:true, J12:true
};
var food_only = '.food-only'; //飲食店不可ブロック

var most_empty_pos_right = [null,null];
var firstday_pos = [];
var secondday_pos = [];
var firstday_total = parseInt('0');
var secondday_total = parseInt('0');

(function($){

  var options = '#how_days_wgn,#how_days_luck,#how_days_ene';
  var panels = '#panel1_click, #panel2_click';

  function isEmpty(status){
    return (status == '' || status == '空き' || typeof status == 'undefined');
  }

  // テキストと値を一括変更
  function generalWriter(){
    $('#firstday_positions').text(firstday_pos.length?firstday_pos.sort():'選択なし');　
    $('#firstday_total').text(firstday_total.toLocaleString());
    $('#secondday_positions').text(secondday_pos.length?secondday_pos.sort():'選択なし');
    $('#secondday_total').text(secondday_total.toLocaleString());
    $('#position_total').text(firstday_pos.length+secondday_pos.length); /* 場所数だけ数える */
    $('#price_total').trigger('calcTotal');
    if(firstday_total > 0 && secondday_total > 0){    /* 両日出店かそうでないかを自動で選択する */
      $('#how_days_shop').val("両日出店");
    }else if(firstday_total > 0 && secondday_total == 0){
      $('#how_days_shop').val("土曜のみ出店");
    }else if(firstday_total == 0 && secondday_total > 0){
      $('#how_days_shop').val("日曜のみ出店");
    }else{
      $('#how_days_shop').val("");
    }
    return this;
  };


  // 読み込み後の動作
  $(window).on('load', function(){
    //予約状況を一括取得（1日目のみ）
    $(panels).trigger('setScrollPosition');
    $('#panel1_click').trigger('checkAllReserveStatus');
    $(options).trigger('reset');
    return generalWriter();
  });
  //リセット
  function resetData(){
    $('.reserve_place').trigger('changeToUnChecked');
    $(options).trigger('reset');
    $('#how_days_shop').val("");
  }


  //　合計金額
  $('#price_total')
  .on('calcTotal', onCalcTotal);

  function onCalcTotal(){
    var price = getTotal().toLocaleString();
    $(this).text(price);
    $('#price_total_input').val(price);
  }

  function getTotal(){
    return firstday_total+secondday_total+getOptionPrice();
  }



  //郵便番号検索
  $('#add_from_zip')
  .on('click', getZipCode);

  function getZipCode(e){
    var zip = $('#zip').val().replace(/[\-ｰーー—]/g,'');
    zip = changeZenHan(zip);
    if(zip.length != 7) return $('#zip').addClass('parsley-error');
    $('#zip').val('検索中...');
    var xhr = $.ajax('https://api.zipaddress.net/?zipcode=' + zip);
    return xhr.then(function(json) {
      $('#zip').val(zip);
      if (json.code == 200) {
        $('#zip').removeClass('parsley-error');
        return $('#add_base').val(json.data.fullAddress);
      }else{
        $('#zip').addClass('parsley-error');
      }
    });
  }
  //全角半角
  function changeZenHan(text){
    return text.replace(/[０-９]/g, function(s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    });
  }



  // 飲食店制御 飲食店を選択したら選択できる場所が制限される
  $('#food_shop').on('change', checkFoodSalePlace ).trigger('change');
  function isCanActivatePlace(is_food_shop){
    switch (true) {
      case (  $('#food_shop').is(':checked') &&  is_food_shop ): //飲食が選択されていてtargetが飲食ブースだった場合
      case ( !$('#food_shop').is(':checked') && !is_food_shop ): //飲食が選択されてなくてtargetが飲食ブースでなかった場合
        return true;
      case (  $('#food_shop').is(':checked') && !is_food_shop ): //飲食が選択されていてtargetが飲食ブースでなかった場合
      case ( !$('#food_shop').is(':checked') &&  is_food_shop ): //飲食が選択されてなくてtargetが飲食ブースだった場合
      default:
        return false;
    }
  }
  function checkFoodSalePlace(e){
    if($(this).is(':checked')) {
      $('.reserve_place').not(food_only)
        .prop('disabled',true).parent('label').addClass('disabled-position');
      $('.reserve_place').not(food_only)
        .filter(':checked').prop('checked',false).trigger('changeToUnChecked');
      $(food_only).prop('disabled', false).parent('label').removeClass('disabled-position');
    } else {
      $('.reserve_place').not(food_only)
        .prop('disabled', false).parent('label').removeClass('disabled-position');
      $(food_only)
        .prop('disabled',true).parent('label').addClass('disabled-position')
      $(food_only)
        .filter(':checked').prop('checked',false).trigger('changeToUnChecked');
    }
  }

  //スクロールボタン
  $('#scroll-button-left,#scroll-button-right').on('click', onScrollPanel);
  function onScrollPanel(e){
    var $target = $('.panel.is-active');
    var direction = this.id.match('left') ? -1 : 1;
    var distance = $target.width()*0.8 || 300;
    var result = $target.scrollLeft() + (distance * direction);
    $target.animate({scrollLeft: result}, 250, 'swing');
    return false;
  }

  //日付変更タブ
  $(panels).each(initPanels)
  .on('checkAllReserveStatus', onCheckAllReserveStatus)
  .on('toggleActive', onToggleActivePanel)
  .on('click', onClickPanel)
  .on('setScrollPosition', onSetScrollPosition);

  //初期化
  function initPanels(index){
    this.day_num = Number(this.id.match(/[0-9]/)[0]);
    this.another_one = this.day_num == 1 ? 2 : 1;
  }
  //スクロール位置の変更
  function onSetScrollPosition(e,x,y,target){
    target = target || '#'+this.id.replace('_click','');
    var def_x = $(target).find('img.street-map').width() - $(target).width();
    x = x || 0;
    x -= 130;
    //x = def_x + x - 130 || 0 //def_x;
    if(x > 8800) x = 0; //最右端は0に戻す。ハードコーデイング
    $(target).scrollLeft(x);
    //console.log('onSetScrollPosition',x,y,target);
    return this;
  };
  //GAS
  function onCheckAllReserveStatus(e){
    $('.reserve_place').trigger('setLoading');
    $.ajax({
      url: CHECK_SHEET_GAS,
      dataType: 'jsonp',
      data: {
        action: 'check_sheet_all',
        day: 'day'+this.day_num
      },
      success: sucessAllReserveStatus,
      error: errorAllReserveStatus
    });
  }
  function sucessAllReserveStatus(responce){
    var data = responce.params.parameter.status;
    $('.reserve_place').trigger('setAllReserveStatus',[data.day, data.sheet]);
  }
  function errorAllReserveStatus(responce){
    showError('['+responce.status+'] ただ今アクセスが集中しており空き状況が取得のプログラムが実行できませんでした。一度ブラウザを閉じて、しばらく経ってから再度アクセスしてください。');
  }
  //パネルドグル
  function onToggleActivePanel(e){
    if($(this).parent('li').hasClass("is-active")){
      $(this).parent('li').addBack()
      .add('#panel'+this.day_num).removeClass("is-active");
    }else{
      $(this).parent('li').addBack()
      .add('#panel'+this.day_num).addClass("is-active");
    }
  }
  //クリック
  function onClickPanel(e){
    //予約状況を確認のために更新する
    $(this).trigger('checkAllReserveStatus');
    if(!$(this).parent('li').hasClass("is-active")){
      $(this).trigger('toggleActive');
      $('#panel'+this.another_one+'_click').trigger('toggleActive');
    }
    return this;
  }


  //　出店枠
  $('.reserve_place').each(initReserve)
  .on('setAllReserveStatus', onSetAllReserveStatus)
  .on('checkReserveStatus', onCheckReserveStatus)
  .on('changeToChecked', onChangeReserveChecked)
  .on('changeToUnChecked', onChangeReserveUnChecked)
  .on('change', onChangeReserve)
  .on('setLoading', onSetLoading);
  $('.bazarmap_label')
  .on('touchstart',function(){ console.log('hello'); $(this).removeClass("touchend"); })
  .on('touchend',function(){ $(this).addClass("touchend"); });
  //初期化
  function initReserve(index){
    var data = this.id.split('_');
    this.day = data[1],
    this.val = data[2].toUpperCase(),
    this.block = this.val.match(/[A-J]/)[0],
    this.number = this.val.match(/[0-9]+/)[0],
    this.fee = price[this.block];
    this.is_use_ene = !(not_ene[this.val])
    this.is_food_shop = $(this).hasClass('food-only');
    this.is_ex_place = $(this).hasClass('ex-place');
    this.is_ex1_place = $(this).hasClass('ex1-place');
    this.set_target_$ = $(this).parent('label').addBack();
    if(this.is_food_shop) this.fee = price[this.block+'C'];
    if(this.is_ex_place) this.fee = price[this.block+'EX'];
    if(this.is_ex1_place) this.fee = price[this.block+'EX'];
    $(this)
    .addClass(this.is_use_ene?'can_ene':'not_ene')
    .prop('disabled',true); //読み込み完了まではさわれないように
  }
  //全ての予約状況をチェック
  function onSetAllReserveStatus(e,day,data){
    if( day != this.day ) return false;
    var day_num = Number(this.day.replace('day',''));
    var col = Number(this.number)-1;
    var row = BLOCK_ARREY.indexOf(this.block);
    var status = data[row][col];
    var posistion_x = this.set_target_$.offset().left;
    if(isEmpty(status) && isCanActivatePlace(this.is_food_shop) ){
      this.set_target_$.removeClass('reserved').removeClass('position-load').prop('disabled',false);
      //右側の空席を優先表示する
      //if(most_empty_pos_right[day_num-1] === null || most_empty_pos_right[day_num-1] < posistion_x){
      //左側の空席を優先表示する
      if(most_empty_pos_right[day_num-1] === null || most_empty_pos_right[day_num-1] > posistion_x){
        most_empty_pos_right[day_num-1] = posistion_x;
        $('#panel'+day_num+'_click').trigger('setScrollPosition',[most_empty_pos_right[day_num-1]]);
        //console.log('most_empty_pos_right',status,most_empty_pos_right[day_num-1]);
      }
      return this;
    }else if(isEmpty(status) && !isCanActivatePlace(this.is_food_shop) ){
      this.set_target_$.addClass('disabled-position').removeClass('position-load').prop('disabled',true);
      return $(this).trigger('changeToUnChecked');
    }else{
      this.set_target_$.addClass('reserved').removeClass('position-load').prop('disabled',true);
      return $(this).trigger('changeToUnChecked');
    }
  }
  //GAS 予約状況チェック
  function onCheckReserveStatus(e){
    $(this).trigger('setLoading');
    //console.log('onCheckReserveStatus');
    $.ajax({
      url: CHECK_SHEET_GAS,
      dataType: 'jsonp',
      data: {
        action: 'check_sheet',
        id: this.id,
        block: this.block,
        number: this.number,
        day: this.day,
      },
      success: sucessReserveStatus,
      error: errorReserveStatus
    });
  }
  function sucessReserveStatus(responce){
    var data = responce.params.parameter.status;
    if(isEmpty(data.status)){
      $('#'+data.id)[0].set_target_$.removeClass('reserved').removeClass('position-load').prop('disabled',false);
      $('#'+data.id).trigger('changeToChecked');
    }else{
      alert('ご希望の出店枠【'+data.day.substr(-1,1)+'日目 '+data.name+'】はすでに予約されています。');
      $('#'+data.id)[0].set_target_$.addClass('reserved').removeClass('position-load').prop('disabled',true);
      $('#'+data.id).trigger('changeToUnChecked');
    }
  }
  function errorReserveStatus(responce){
    showError('['+responce.status+'] ただ今アクセスが集中しており空き状況が取得のプログラムが実行できませんでした。一度ブラウザを閉じて、しばらく経ってから再度アクセスしてください。');
  }
  //チェックを入れる
  function onChangeReserveChecked(e){
    if($(this).hasClass('position-checked')) return this;
    this.set_target_$.addClass('position-checked').removeClass('position-load');
    $(this).prop('checked',true);
    calcReserveFee(this.fee,this.val,this.day);
  }
  //チェックを外す
  function onChangeReserveUnChecked(e){
    if(!$(this).hasClass('position-checked')) return this;
    this.set_target_$.removeClass('position-checked').removeClass('position-load');
    $(this).prop('checked',false);
    calcReserveFee(-this.fee,this.val,this.day);
  }
  //出店価格を変更
  function calcReserveFee(fee,name,day){
    $('#how_days_ene').trigger('checkUseEne');
    var idx = '';
    if(day == 'day1') {
      idx = $.inArray(name, firstday_pos);
      if(fee>0) firstday_pos.push(name);
      else firstday_pos.splice(idx, 1);
      firstday_total += fee;
    }else{
      idx = $.inArray(name, secondday_pos);
      if(fee>0) secondday_pos.push(name);
      else secondday_pos.splice(idx, 1);
      secondday_total += fee;
    }
    return generalWriter();
  }

  //値が変わったら
  function onChangeReserve(e){
    if ($(this).is(':checked')) $(this).trigger('checkReserveStatus');
    else $(this).trigger('changeToUnChecked');
  }
  //ローデイング
  function onSetLoading(e){
    this.set_target_$.addClass('position-load').prop('disabled',false);
  }



  // オプション
  $(options)
  .each(initOption)
  .on('change', onChangeOption)
  .on('reset', onResetOption)
  .on('checkUseEne', onCheckUseEne);

  function initOption(e){
    this.price = price[this.name];
  }

  function onChangeOption(e){
    $('#price_total').trigger('calcTotal');
  }

  function onResetOption(e){
    $(this).val(0).trigger('change')
  }

  function getOptionPrice(){
    var price = 0;
    $(options).each(function(e){
      price += this.price * $(this).val();
    })
    return price;
  }

  function onCheckUseEne(e){
    if(this.name !== '電源') return this;
    //電源使える場所を1つでも選んでいたら
    if($('.can_ene:checked').length > 0){
      $(this).prop('disabled', false);
    }else if($('.can_ene:checked').length == 0){
      $(this).prop('disabled', true).trigger('reset');
    }
    //どちらかの日が電源使える場所が選択されてなかったら選択減らす
    if(($('#panel1 .can_ene:checked').length == 0) || ($('#panel2 .can_ene:checked').length == 0)){
      if($(this).val() == 2) $(this).val(1).trigger('change');
      $(this).find('option[value=2]').remove();
    }else if($(this).find('option').length < 3){
      $(this).append('<option value="2">2</option>');
    }
  }



  /*
  ------------------  バリデート -------------------------------------
  */

  //整形データ保持
  var form_fields;
  if($('#order-form').length){
    $('#order-form').parsley()
    .on('field:validated', onErrorValidated)
    .on('form:submit', function(e){
      form_fields = getConvertPost(e.fields);
      // // test
      // e.send_data = {}
      // e.send_data['受付番号'] = 0;
      // e.send_header = '';
      // return sendMail(e);
      return sendReserveCheck(e);
    });
  }
  //エラー状態
  function onErrorValidated(e){
    var ok = $('.parsley-error').length === 0;
    $('.bs-callout-info').toggleClass('hidden', !ok);
    $('.bs-callout-warning').toggleClass('hidden', ok);
  }
  //フォーム情報整形
  function getConvertPost(data){
    var post_data = {};
    data.forEach(function(field, index, array){
      var data = {
        name: field.element.name,
        value: field.value
      };
      post_data[field.element.name] = field.value;
    });
    post_data['金額'] = getTotal();
    post_data.UA = window.navigator.userAgent;
    return post_data;
  }



  /*
  ------------------  submit後の最終処理 -------------------------------------
  */

  //GASへアクセスして予約状況をチェックする
  function sendReserveCheck(e){
    //e.data = getConvertPost(e.fields);
    $('#locad_screen').addClass('show');
    $('#locad_screen_message').text('予約状況をチェック中...');
    form_fields.action = 'check_reserve';
    //console.log( 'POST_DATA', e.fields );
    $.ajax({
      url: CHECK_SHEET_GAS, dataType: 'jsonp', data: form_fields,
      beforeSend: function(){ $('#submit').prop('disabled', true) },
      complete: function(){ $('#submit').prop('disabled', false) },
      error: function(responce){
        showError('ただ今アクセスが集中しており空き状況が取得のプログラムが実行できませんでした。一度ブラウザを閉じて、しばらく経ってから再度アクセスしてください。');
      },
      success: function(responce){
        successNextStep(responce.params,sendWriteReserve)
      }
    });
    return false;
  }
  //GASへアクセスして予約状況を書き込む
  function sendWriteReserve(e){
    $('#locad_screen').addClass('show');
    $('#locad_screen_message').text('仮受付を書き込み中...');
    form_fields.action = 'write_reserve';
    // console.log('sendWriteReserve', form_fields);
    $.ajax({
      url: WRITE_SHEET_GAS, dataType: 'jsonp', data: form_fields,
      beforeSend: function(){ $('#submit').prop('disabled', true) },
      complete: function(){ $('#submit').prop('disabled', false) },
      error: function(responce){
        // console.log(responce);
        showError('ただ今アクセスが集中しており予約受付のプログラムが実行できませんでした。一度ブラウザを閉じて、しばらく経ってから再度アクセスしてください。');
      },
      success: function(responce){
        successNextStep(responce.params,sendMail)
      }
    });
    return false;
  }
  //GASへアクセスしてメールを送信する
  function sendMail(e){
    $('#submit').prop('disabled', false);
    $('#locad_screen').addClass('show');
    $('#locad_screen_message').text('メールを用意しています。');
    form_fields.action = 'send_mail';
    form_fields.token = $('#token').val();
    form_fields['受付番号'] = e.send_data['受付番号'];
    form_fields.send_header = e.send_header;
    $.ajax({
      url: "mailer.php",
      type: "POST",
      postType: "json",
      data: form_fields,
      beforeSend: function(xhr){
        xhr.setRequestHeader('X-CSRF-TOKEN', form_fields.token);
        $('#submit').prop('disabled', true);
      },
      complete: function(){ $('#submit').prop('disabled', false) },
      error: function(responce){
        window.location.href = 'thanks_get.html';
      },
      success: function(responce){
        // console.log(responce);
        successNextStep(responce,function(){
          window.location.href = 'thanks.html';
        })
      }
    });
    return false;
  }
  function sendMailbyGAS(e){
    $('#locad_screen').addClass('show');
    $('#locad_screen_message').text('メールを用意しています。');
    form_fields.action = 'send_mail';
    form_fields['受付番号'] = e.send_data['受付番号'];
    form_fields.send_header = e.send_header;
    $.ajax({
      url: SEND_MAIL_GAS, dataType: 'jsonp', data: form_fields,
      beforeSend: function(){ $('#submit').prop('disabled', true) },
      complete: function(){ $('#submit').prop('disabled', false) },
      error: function(responce){
        window.location.href = 'thanks_get.html';
      },
      success: function(responce){
        successNextStep(responce.params,function(){
          window.location.href = 'thanks.html';
        })
      }
    });
    return false;
  }
  function showError(message,callback){
    resetData();
    $(panels).trigger('checkAllReserveStatus');
    $('#locad_screen').removeClass('show');
    alert(message);
    return callback;
  }
  function successNextStep(params,callback){
    if(params.status == 'error') return showError(params.message);
    $('#locad_screen_message').text(params.message);
    return callback(params);
  }

  // - - - - - - - - - - - - - - - - - - - - - -
  // デバッグ用
  //
  $("#others").on('change',function(){
    if($(this).val() !== 'http://form.yurinoki-st.lc:8081/dist/') return this;
    $('#shop_name').val('PLANPOT DEISGN WORKS');
    $('#shop_furigana').val('ぷらんぽっとでざいんわーくす');
    $("#owner").val('鈴木力哉');
    $("#owner_furigana").val('すずきりきや');
    $("#zip").val('430-0856');
    $("#add_base").val('静岡県浜松市中区田町326-25');
    $("#add_build").val('KJスクエア 3F');
    $("#tel").val('080-3070-4318');
    $("#fax").val('053-123-0120');
    $("#email").val('honey00penguin@gmail.com');
    $("#material_shop").prop('checked', true);
    // $("#food_shop").prop('checked', true);
    // $("#work_shop").prop('checked', true);
    $("#hinmoku").val('デジタルガジェット');
    // $("#how_days_shop").val('');
    $("#how_days_ene").val(1);
    // $("#how_days_wgn").val(1);
    // $("#how_days_luck").val(1);
    $("#bankmeigi").val('プランポットスズキリキヤ');
    $("#others").val('その他の項目');
  });

})(jQuery);
